import {useState, useEffect} from 'react';
import { useToken } from 'hooks/useToken'
import { decodeStorage, encodeStorage, removeStorage } from 'functions/storageBase64';
import { getCardList } from 'services/Cards'


export function useArrayCard(){

    const { newToken, liveToken }  = useToken()
    const session_token = decodeStorage('session_token')
    const sears_numero_internet = decodeStorage('sears_numero_internet')
    const cardending = decodeStorage('cardending')

    const [responseCardList, setResponseCardList] = useState()
    const [associatedCards, setAssociatedCards] = useState()
    const [errorCode, setErrorCode] = useState()
    const [addCardNew, setAddCardNew] = useState(false)

    useEffect(()=>{
        if(session_token){
            if( (!sears_numero_internet || sears_numero_internet === "undefined") || (!cardending || cardending === "undefined") ){
                // liveToken()
                // getCardList()
                // .then(setResponseCardList)
            }else{
                liveToken()
                getCardList()
                .then(setResponseCardList)
            }
        }
    },[newToken, addCardNew])

    useEffect(()=>{
        if(responseCardList){
            if(responseCardList.statusCode === 200){
                if(responseCardList.data){
                    encodeStorage('associatedCards', responseCardList?.data.cards)
                    setAssociatedCards(responseCardList?.data.cards)
                    setAddCardNew(false)
                }
            }
            else if(responseCardList.statusCode === 400){
                console.log('1')
                let codeError = JSON.parse(responseCardList?.data)
                setErrorCode(codeError)
                if( JSON.parse(responseCardList?.data).codMen === "ERR001" ){
                    console.log('2')
                    removeStorage('cardending')
                    removeStorage('sears_numero_internet')
                    if( (!sears_numero_internet || sears_numero_internet === "undefined") || (!cardending || cardending === "undefined") ){
                        console.log('3')
                        removeStorage('lastConsultData')
                        removeStorage('associatedCards')
                        //window.location.reload()
                    }
                    else{
                        console.log('4')
                        window.location.reload()
                    }
                }
            }
            else if(responseCardList.statusCode >= 500){
                setErrorCode(responseCardList.statusCode)
            }
        }
    },[responseCardList])

    const [validateCards, setValidateCards] = useState(false)
    useEffect(()=>{
        if(associatedCards){
            if(associatedCards.length >= 1){
                encodeStorage('cardending', associatedCards[0]?.card_ending)
                encodeStorage('sears_numero_internet', associatedCards[0]?.no_internet)
                setValidateCards(true)
            }
        }
    },[associatedCards])



    const udCardsArray = (value) =>{
        setAddCardNew(value)
    }

    return{
        validateCards,
        associatedCards,
        errorCode,
        udCardsArray,
        setValidateCards
    }
}